import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-doctor-appointments-page',
    templateUrl: './doctor-appointments-page.component.html',
    styleUrls: ['./doctor-appointments-page.component.css'],
    standalone: false
})
export class DoctorAppointmentsPageComponent implements OnInit {

  name: string = "";
  token: any;

  dateList: Date[] = [];
  slots: any[] = [];
  appointments: any[] = [];
  doctor: any;

  currentDay: Date = new Date();

  constructor(public utility: UtilitiesService, private api: ApiService, public datepipe: DatePipe, private router: Router) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.name = localStorage.getItem('name')!;

    this.generateDateList();
  }

  ngOnInit(): void {
    let item = localStorage.getItem('employee');
    if (item) {
      this.doctor = JSON.parse(item);

      if (this.doctor)
        this.getDoctorSlots(this.doctor.id);
    }
  }

  getDoctorSlots(id: any) {
    this.utility.loading = true;
    const sub = this.api.get('appointments/doctor/all/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        //this.slots = objects.schedules;
        this.slots = objects.appointments;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  generateDateList() {
    this.dateList = [];
    for (let i = 0; i < 3; i++) {
      const date = new Date(this.currentDay.getFullYear(), this.currentDay.getMonth(), this.currentDay.getDate() + i);
      this.dateList.push(date);
    }
  }

  goToPrevious() {
    this.currentDay.setDate(this.currentDay.getDate() - 3);
    this.generateDateList();
  }

  goToNext() {
    this.currentDay.setDate(this.currentDay.getDate() + 3);
    this.generateDateList();
  }

  getThisDaySlots(date: any) {
    let select_date = this.datepipe.transform(date, 'yyyy-MM-dd');
    return this.slots.filter(i => this.datepipe.transform(i.schedule.date_time, 'yyyy-MM-dd') === select_date);
  }

  goToDetails(appointment: any) {
    localStorage.removeItem('appointment');
    localStorage.setItem('appointment', JSON.stringify(appointment));
    
    //this.router.navigate(['appointment_details']);
    this.router.navigate(['view_details']);
  }
}
